'use client';

import { SessionProvider } from 'next-auth/react';
import type { ReactNode } from 'react';

/**
 * Провайдер сессии для клиентских компонентов.
 *
 * Нужен шапке, чтобы она знала, вошёл человек или нет. Отдельный файл, а не
 * строка в лейауте, потому что провайдер клиентский, а лейаут серверный:
 * пометив 'use client' весь лейаут, мы потеряли бы серверную генерацию
 * страниц и метаданных.
 *
 * refetchOnWindowFocus отключён осознанно: вкладку переключают часто, а
 * каждый возврат означал бы лишний запрос к серверу без пользы для человека.
 * Сессия обновится при переходе по страницам и при действиях входа и выхода.
 */
export function AuthProvider({ children }: { children: ReactNode }) {
  return <SessionProvider refetchOnWindowFocus={false}>{children}</SessionProvider>;
}
